module.exports = __webpack_public_path__ + "img/Desk Stationeryd23.2cf75b27.jpg";